import { Type, ShapeTypeEnumType, Position, Icon, Numbering, } from '@wix/ambassador-seating-v1-seating-plan/types';
import { isDarkColor } from '@wix/panda-js-utils';
import { COLORS } from '../constants';
import { IconType, LabelsPosition, SHAPE, SeatingSequence, } from '../interfaces';
import { degreesToRadians } from './utils';
const getCategoriesColorsMap = (categories) => {
    const categoriesColorsMap = {};
    categories.forEach(category => {
        categoriesColorsMap[category.id] = category.config.color;
    });
    return categoriesColorsMap;
};
export const elementsToShapes = (plan, shouldUseCategories, uiPropertiesReadEnabled, onlyShapeIds) => {
    const { categories, sections } = plan;
    const categoriesColorsMap = shouldUseCategories ? getCategoriesColorsMap(categories) : {};
    const categoryProps = (element) => {
        if (shouldUseCategories) {
            const categoryColor = categoriesColorsMap[element.categoryId];
            return {
                categoryId: element.categoryId,
                shapeColor: categoryColor,
                shapeTextColor: isDarkColor(categoryColor) ? COLORS.WHITE : COLORS.TEXT,
            };
        }
        return {
            categoryId: element.categoryId,
        };
    };
    const include = (elementId) => (onlyShapeIds ? onlyShapeIds.includes(elementId) : true);
    return sections
        .flatMap((section) => section.elements.map((element) => {
        var _a, _b, _c;
        return include(element.id)
            ? Object.assign(Object.assign(Object.assign({}, getElementConfig(element, uiPropertiesReadEnabled)), categoryProps(element)), { label: element.title, seats: element.places, type: getType(element, uiPropertiesReadEnabled), capacity: element.capacity, startAt: (_b = (_a = element.sequencing) === null || _a === void 0 ? void 0 : _a.startAt) === null || _b === void 0 ? void 0 : _b.toString(), reverseDirection: (_c = element.sequencing) === null || _c === void 0 ? void 0 : _c.reverseOrder, id: element.id, sectorLabel: section.default ? '' : section.title, reservationOptions: element.reservationOptions })
            : null;
    }))
        .filter(a => a);
};
export const getElementConfig = (element, uiPropertiesReadEnabled) => {
    if (!uiPropertiesReadEnabled) {
        return element.config;
    }
    const { x, y, zIndex, width, height, rotationAngle, fontSize, cornerRadius, seatSpacing, hideLabel, labelPosition, seatLayout, emptyTopSeatSpaces, text, color, fillColor, strokeColor, strokeWidth, opacity, icon, image, seatNumbering, } = element.uiProperties;
    const config = {
        x,
        y,
        sortId: zIndex,
        width,
        height,
        angle: degreesToRadians(rotationAngle),
        fontSize,
        cornerRadius,
        spacing: seatSpacing,
        hideLabel,
        labelPosition: getShapeLabelPosition(labelPosition),
        layout: seatLayout,
        empty: emptyTopSeatSpaces,
        text,
        color,
        fillColor,
        strokeColor,
        strokeWidth,
        opacity: opacity / 100,
        icon: getShapeIcon(icon),
        image: getShapeImage(image),
        sequence: getShapeSequence(seatNumbering),
    };
    return config;
};
export const getType = (element, uiPropertiesReadEnabled) => {
    var _a, _b;
    switch (element.type) {
        case Type.AREA:
            return SHAPE.AREA;
        case Type.ROW:
            return SHAPE.ROW;
        case Type.ROUND_TABLE:
            return SHAPE.ROUND_TABLE;
        case Type.TABLE:
            return SHAPE.TABLE;
        case Type.SHAPE:
            return uiPropertiesReadEnabled ? getShapeType((_a = element.uiProperties) === null || _a === void 0 ? void 0 : _a.shapeType) : (_b = element.config) === null || _b === void 0 ? void 0 : _b.shape;
        default:
            return undefined;
    }
};
export const getShapeLabelPosition = (labelPosition) => {
    var _a;
    const map = {
        [Position.LEFT]: LabelsPosition.LEFT,
        [Position.RIGHT]: LabelsPosition.RIGHT,
        [Position.BOTH]: LabelsPosition.BOTH,
    };
    return (_a = map[labelPosition]) !== null && _a !== void 0 ? _a : LabelsPosition.NONE;
};
export const getShapeType = (shapeType) => {
    var _a;
    const map = {
        [ShapeTypeEnumType.ELLIPSE]: SHAPE.CIRCLE,
        [ShapeTypeEnumType.ICON]: SHAPE.ICON,
        [ShapeTypeEnumType.IMAGE]: SHAPE.IMAGE,
        [ShapeTypeEnumType.LINE]: SHAPE.LINE,
        [ShapeTypeEnumType.RECTANGLE]: SHAPE.RECTANGLE,
        [ShapeTypeEnumType.TEXT]: SHAPE.TEXT,
    };
    return (_a = map[shapeType]) !== null && _a !== void 0 ? _a : undefined;
};
// TODO: start using ambassador types once migrated out of config
export const getShapeIcon = (icon) => {
    var _a;
    const map = {
        [Icon.CHECKROOM]: IconType.checkroom,
        [Icon.DRINKS]: IconType.drinks,
        [Icon.ELEVATOR]: IconType.elevator,
        [Icon.ENTER]: IconType.enter,
        [Icon.EXIT]: IconType.exit,
        [Icon.FOOD]: IconType.food,
        [Icon.SMOKING]: IconType.smoking,
        [Icon.STAGE]: IconType.stage,
        [Icon.STAIRS]: IconType.stairs,
        [Icon.WC]: IconType.wc,
        [Icon.WC_MEN]: IconType.wcMen,
        [Icon.WC_WOMEN]: IconType.wcWomen,
    };
    return (_a = map[icon]) !== null && _a !== void 0 ? _a : undefined;
};
export const getShapeImage = (image) => {
    if (!image) {
        return undefined;
    }
    return {
        id: image.id,
        originalWidth: image.width,
        originalHeight: image.height,
        uri: image.uri,
    };
};
export const getShapeSequence = (seatNumbering) => {
    var _a;
    const map = {
        [Numbering.ALPHABETICAL]: SeatingSequence.ALPHABETIC,
        [Numbering.NUMERIC]: SeatingSequence.NUMERIC,
        [Numbering.ODD_EVEN]: SeatingSequence.NUMERIC_EVEN_OR_ODD,
    };
    return (_a = map[seatNumbering]) !== null && _a !== void 0 ? _a : undefined;
};
//# sourceMappingURL=elements-to-shapes.js.map